<template>
  <div>
    <!-- START DATA DIRI -->
    <DataBadanHukum :allRejectedFields="allRejectedFields" :rejectionMessages="rejectionMessages" @updated="loadData" @dirty="markFieldAsFixed" />
    <DataPIC :allRejectedFields="allRejectedFields" :rejectionMessages="rejectionMessages" @updated="loadData" @dirty="markFieldAsFixed" />

    <b-card no-body class="mb-1" v-if="currentUser.info.role_id === 3">
      <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Data Diri</span>
        <b-button v-b-toggle.accordion-1 variant="yellow" class="chevron">
          <span class="when-open">
            <b-icon icon="chevron-up" />
          </span>
          <span class="when-closed">
            <b-icon icon="chevron-down" />
          </span>
        </b-button>
      </b-card-header>

      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <b-alert v-if="sectionRejectionMessages.length > 0" show variant="warning" class="mb-4">
              <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
              <strong>Berdasarkan hasil verifikasi, pengajuan saat ini belum dapat disetujui.</strong>
              <div v-for="(msg, idx) in sectionRejectionMessages" :key="idx" class="mt-2 ml-4">
                <p class="mb-1"><strong>Alasan:</strong> {{ msg.note }}</p>
                <div v-if="msg.fields && msg.fields.length > 0">
                  <p class="mb-0"><strong>Data atau informasi yang memerlukan perbaikan (Data Diri):</strong></p>
                  <ol class="mb-2">
                    <li v-for="f in msg.fields" :key="f.field" class="font-weight-bold">{{ f.label }}</li>
                  </ol>
                </div>
              </div>
              <hr v-if="sectionRejectionMessages.length > 0">
              <p class="mt-2 mb-0">Untuk dapat melakukan pengajuan kembali mohon dapat memperbarui Data Diri anda pada kolom yang berwarna merah di bawah ini.</p>
            </b-alert>

            <div class="container">
              <div v-if="isLoading" class="text-center my-4">
                <b-spinner
                  label="Loading..."
                  variant="primary"
                  small
                ></b-spinner>
                <p>Memuat data, mohon tunggu...</p>
              </div>
              <b-form v-else @submit.prevent="updateDataDiri">
                <!-- START NAMA LENGKAP -->
                <div class="row">
                  <span style="font-size: 12px">Note : (*) Wajib diisi</span>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="name" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nama_depan') || allRejectedFields.includes('nama_belakang')}">Nama Lengkap Sesuai KTP *</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.name"
                        placeholder="Nama Lengkap Sesuai KTP"
                        :class="{'is-invalid': allRejectedFields.includes('nama_depan') || allRejectedFields.includes('nama_belakang')}"
                        disabled
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <!-- END NAMA LENGKAP -->

                <!-- START JENIS KELAMIN DAN KEWARGANEGARAAN -->
                <div class="row">
                  <div class="col">
                    <div class="email mt-3">
                      <span :class="{'text-danger font-weight-bold': allRejectedFields.includes('jenis_kelamin')}">Jenis Kelamin *</span>
                      <br />
                      <div class="d-flex mt-2">
                        <div class="form-check">
                          <b-form-radio-group
                            v-model="form.jenis_kelamin"
                            :options="options.jenis_kelamin"
                            :class="{'is-invalid': allRejectedFields.includes('jenis_kelamin')}"
                            required
                          ></b-form-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kewarganegaraan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('kewarganegaraan') || allRejectedFields.includes('nationality')}">Kewarganegaraan *</label>
                      <br />
                      <b-form-select
                        v-model="form.kewarganegaraan"
                        :options="options.kewarganegaraan"
                        :class="{'is-invalid': allRejectedFields.includes('kewarganegaraan') || allRejectedFields.includes('nationality')}"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <!-- END JENIS KELAMIN DAN KEWARGANEGARAAN -->

                <!-- START NO TELEPON -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTelepon" :class="{'text-danger font-weight-bold': allRejectedFields.includes('no_handphone')}"
                        >No. Ponsel yang terhubung ke WA *</label
                       >
                      <br />
                      <BFormInputWithMask
                        v-model="form.no_handphone"
                        placeholder="Nomor handphone"
                        :invalid="allRejectedFields.includes('no_handphone') || allRejectedFields.includes('phone_number')"
                        :disabled="ekyc_verified || no_handphone_disable"
                        :required="true"
                        @blur="validatePhoneNumber"
                      />
                      <div v-if="errors.no_handphone" class="text-danger">
                        {{ errors.no_handphone }}
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTeleponalternatif" :class="{'text-danger font-weight-bold': allRejectedFields.includes('no_hp_alternatif')}"
                        >No. Telepon/HP Alternatif (opsional)</label
                      >
                      <br />
                      <BFormInputWithMask
                        v-model="form.no_hp_alternatif"
                        :invalid="allRejectedFields.includes('no_hp_alternatif') || allRejectedFields.includes('alternative_phone_number')"
                        :required="true"
                      />
                    </div>
                  </div>
                </div>
                <!-- END NO TELEPON -->

                <!-- START TEMPAT DAN TANGGAL LAHIR -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="tempatLahir" :class="{'text-danger font-weight-bold': allRejectedFields.includes('tempat_lahir')}">Tempat Lahir *</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.tempat_lahir"
                        placeholder="Masukan tempat lahir"
                        :class="{'is-invalid': allRejectedFields.includes('tempat_lahir')}"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <BFormInputWithMask
                        type="date"
                        label="Tanggal Lahir"
                        v-model="form.tanggal_lahir"
                        :disabled="ekyc_verified"
                        :required="true"
                        :invalid="allRejectedFields.includes('tanggal_lahir') || allRejectedFields.includes('date_of_birth')"
                        :label-class="allRejectedFields.includes('tanggal_lahir') || allRejectedFields.includes('date_of_birth') ? 'text-danger font-weight-bold' : ''"
                      />
                    </div>
                  </div>
                </div>
                <!-- END TEMPAT DAN TANGGAL LAHIR -->

                <!-- START ALAMAT EMAIL -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="email">Alamat Email *</label>
                      <br />
                      <BFormInputWithMask
                        v-model="email"
                        placeholder="Alamat Email"
                        :disabled="true"
                        :required="true"
                        @blur="validatePhoneNumber"
                        type="email"
                        :mask="isUpdate ? true : false"
                      />
                    </div>
                  </div>
                </div>
                <!-- END ALAMAT EMAIL -->

                <!-- START JENIS DAN NOMOR TANDA PENGENAL -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="jenisTandapengenal" :class="{'text-danger font-weight-bold': allRejectedFields.includes('jenis_tanda_pengenal') || allRejectedFields.includes('identity_type')}">Jenis Tanda Pengenal *</label>
                      <br />
                      <b-form-select
                        v-model="form.jenis_tanda_pengenal"
                        :options="options.jenis_tanda_pengenal"
                        :class="{'is-invalid': allRejectedFields.includes('jenis_tanda_pengenal') || allRejectedFields.includes('identity_type')}"
                        :disabled="ekyc_verified"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="nomorTandapengenal" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nomor_tanda_pengenal') || allRejectedFields.includes('identity_number')}">Nomor Tanda Pengenal *</label>
                      <br />
                      <BFormInputWithMask
                        type="number"
                        v-model="form.nomor_tanda_pengenal"
                        placeholder="Nomor Tanda Pengenal"
                        :invalid="allRejectedFields.includes('nomor_tanda_pengenal') || allRejectedFields.includes('identity_number')"
                        disabled
                        @blur="validateNomorTandaPengenal"
                        :maxlength="16"
                        @keydown="
                          (event) =>
                            validationLength(
                              event,
                              form.nomor_tanda_pengenal,
                              16
                            )
                        "
                      />
                      <div
                        v-if="errors.nomor_tanda_pengenal"
                        class="text-danger"
                      >
                        {{ errors.nomor_tanda_pengenal }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END JENIS DAN NOMOR TANDA PENGENAL -->

                <!-- START TEMPAT DAN MASA BERLAKU TANDA PENGENAL -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="tempatTerbit">Tempat Diterbitkan *</label>
                      <br />
                      <b-form-input
                        type="text"
                        placeholder="Tempat diterbitkan"
                        v-model="form.tempat_diterbitkan"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="masa-berlaku"
                        >Masa Berlaku Tanda Pengenal *</label
                      >
                      <br />
                      <div class="form-check form-check-inline">
                        <b-form-input
                          type="text"
                          placeholder="Masa berlaku tanda pengenal"
                          v-model="form.masa_berlaku_tanda_pengenal"
                          required
                        ></b-form-input>
                      </div>
                      <div class="form-check form-check-inline">
                        <b-form-checkbox
                          v-model="form.masa_berlaku_tanda_pengenal"
                          name="checkbox-1"
                          value="seumur hidup"
                          unchecked-value="terbatas"
                        >
                          Seumur hidup
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END TEMPAT DAN MASA BERLAKU TANDA PENGENAL -->

                <!-- START NPWP -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="npwp" :class="{'text-danger font-weight-bold': allRejectedFields.includes('npwp') || allRejectedFields.includes('taxpayer_number')}">NPWP (opsional)</label>
                      <br />
                      <BFormInputWithMask
                        type="number"
                        v-model="form.npwp"
                        placeholder="NPWP"
                        :invalid="allRejectedFields.includes('npwp') || allRejectedFields.includes('taxpayer_number')"
                        @blur="handleBlur(`npwp`)"
                        :callback="() => callbackMasking(`npwp`)"
                        :mask="mask.npwp"
                      />      
                    </div>
                  </div>
                </div>
                <!-- END NPWP -->

                <!-- START NPWP ATTACHMENT -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="npwp_attachment" :class="{'text-danger font-weight-bold': allRejectedFields.includes('npwp_attachment')}"
                        >NPWP Gambar / PDF (Opsional)</label
                      >
                      <br />
                      <b-form-file
                        accept="image/*,application/pdf"
                        :class="{'is-invalid': allRejectedFields.includes('npwp_attachment')}"
                        @change="handleNPWPAttachment"
                      ></b-form-file>
                      <div v-if="this.photo.npwp_attachment" class="mt-2">
                        <div v-if="isPDF(this.photo.npwp_attachment)">
                          <a
                            :href="this.photo.npwp_attachment"
                            target="_blank"
                            class="d-flex align-items-center"
                          >
                            <b-img
                              :src="
                                require('@/assets/images/icon/upload-npwp.jpg')
                              "
                              alt="PDF Preview"
                              style="max-width: 100px"
                            ></b-img>
                            <span class="ml-2"
                              >Klik untuk membuka file PDF</span
                            >
                          </a>
                        </div>
                        <div v-else>
                          <b-img
                            :src="this.photo.npwp_attachment"
                            class="kyc-image"
                            fluid
                            alt="Preview NPWP Attachment"
                          ></b-img>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END NPWP ATTACHMENT -->

                <!-- START ALAMAT KTP -->
                <div class="row">
                  <div class="col">
                    <div class="email mt-3">
                      <label for="alamat-ktp" :class="{'text-danger font-weight-bold': allRejectedFields.includes('alamat') || allRejectedFields.includes('identity_address')}">Alamat Sesuai KTP *</label>
                      <br />
                      <BFormInputWithMask
                        v-model="form.alamat"
                        placeholder="Masukan alamat sesuai KTP"
                        :invalid="allRejectedFields.includes('alamat') || allRejectedFields.includes('identity_address')"
                        :required="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="provinsi" :class="{'text-danger font-weight-bold': allRejectedFields.includes('provinsi_ktp')}">Provinsi *</label>
                      <br />
                      <b-form-select
                        v-model="form.provinsi_ktp"
                        :value.sync="form.provinsi_ktp"
                        :options="options.provinsi_ktp"
                        :class="{'is-invalid': allRejectedFields.includes('provinsi_ktp') || allRejectedFields.includes('identity_province_id')}"
                        @input="provinsiChangeKtp"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kota" :class="{'text-danger font-weight-bold': allRejectedFields.includes('kota_ktp')}">Kota / Kabupaten *</label>
                      <br />
                      <b-form-select
                        v-model="form.kota_ktp"
                        :value.sync="form.kota_ktp"
                        :options="
                          loadingchangeProvinceKTP
                            ? [{ value: null, text: 'Memuat data...' }]
                            : options.kota_ktp
                        "
                        :class="{'is-invalid': allRejectedFields.includes('kota_ktp') || allRejectedFields.includes('identity_city_id')}"
                        :disabled="loadingchangeProvinceKTP"
                        @input="kotaChangeKtp"
                        required
                      ></b-form-select>
                      <small
                        v-if="loadingchangeProvinceKTP"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kota...
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kecamatan">Kecamatan *</label>
                      <br />
                      <b-form-select
                        v-model="form.kecamatan_ktp"
                        :value.sync="form.kecamatan_ktp"
                        :options="
                          loadingKotaChangeKTP
                            ? [{ value: null, text: 'Memuat data...' }]
                            : options.kecamatan_ktp
                        "
                        :disabled="loadingKotaChangeKTP"
                        @input="kecamatanChangeKtp"
                        required
                      ></b-form-select>
                      <small
                        v-if="loadingKotaChangeKTP"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kecamatan...
                      </small>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="desa">Desa / Kelurahan *</label>
                      <br />
                      <b-form-select
                        v-model="form.kelurahan_ktp"
                        :value.sync="form.kelurahan_ktp"
                        :options="
                          loadingKecamatanChangeKTP
                            ? [{ value: null, text: 'Memuat data...' }]
                            : options.kelurahan_ktp
                        "
                        :disabled="loadingKecamatanChangeKTP"
                        @input="kelurahanChangeKtp"
                        required
                      ></b-form-select>
                      <small
                        v-if="loadingKecamatanChangeKTP"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                </div>
                <!-- END ALAMAT KTP -->

                <!-- START ALAMAT TERKINI -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <input
                        type="checkbox"
                        v-model="isSameAddress"
                      />
                      <label for="">Alamat domisili sesuai dengan KTP</label>
                      <br />
                      <label for="alamat-terkini" :class="{'text-danger font-weight-bold': allRejectedFields.includes('alamat_terkini')}">Alamat Domisili</label>
                      <br />
                      <BFormInputWithMask
                        v-model="form.alamat_terkini"
                        placeholder="Masukan alamat domisili"
                        :invalid="allRejectedFields.includes('alamat_terkini')"
                        :required="true"
                        :readonly="isSameAddress"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="provinsi" :class="{'text-danger font-weight-bold': allRejectedFields.includes('provinsi')}">Provinsi</label>
                      <br />
                      <b-form-select
                        v-model="form.provinsi"
                        :disabled="isSameAddress"
                        :options="options.provinsi"
                        :class="{'is-invalid': allRejectedFields.includes('provinsi')}"
                        @input="provinsiChange"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kota" :class="{'text-danger font-weight-bold': allRejectedFields.includes('kota')}">Kota / Kabupaten</label>
                      <br />
                      <b-form-select
                        v-model="form.kota"
                        :disabled="isSameAddress || loadingchangeProvince"
                        :options="options.kota"
                        :class="{'is-invalid': allRejectedFields.includes('kota')}"
                        @input="kotaChange"
                      ></b-form-select>
                      <small
                        v-if="loadingchangeProvince"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kota...
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kecamatan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('kecamatan')}">Kecamatan</label>
                      <br />
                      <b-form-select
                        v-model="form.kecamatan"
                        :disabled="isSameAddress || loadingKotaChange"
                        :options="options.kecamatan"
                        :class="{'is-invalid': allRejectedFields.includes('kecamatan')}"
                        @input="kecamatanChange"
                      ></b-form-select>
                      <small
                        v-if="loadingKotaChange"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kecamatan...
                      </small>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="desa" :class="{'text-danger font-weight-bold': allRejectedFields.includes('kelurahan')}">Desa / Kelurahan</label>
                      <br />
                      <b-form-select
                        v-model="form.kelurahan"
                        :disabled="isSameAddress || loadingKecamatanChange"
                        :options="options.kelurahan"
                        :class="{'is-invalid': allRejectedFields.includes('kelurahan')}"
                      ></b-form-select>
                      <small
                        v-if="loadingKecamatanChange"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                </div>
                <!-- END ALAMAT TERKINI -->

                <!-- START STATUS TEMPAT TINGGAL DAN NEGARA -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="status_tempat_tinggal" :class="{'text-danger font-weight-bold': allRejectedFields.includes('status_tempat_tinggal') || allRejectedFields.includes('residence_status')}">Status Tempat Tinggal *</label>
                      <br />
                      <b-form-select
                        v-model="form.status_tempat_tinggal"
                        :options="options.status_tempat_tinggal"
                        :class="{'is-invalid': allRejectedFields.includes('status_tempat_tinggal') || allRejectedFields.includes('residence_status')}"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="negara" :class="{'text-danger font-weight-bold': allRejectedFields.includes('negara') || allRejectedFields.includes('country')}">Negara *</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.negara"
                        placeholder="Masukan negara"
                        :class="{'is-invalid border-danger': allRejectedFields.includes('negara') || allRejectedFields.includes('country')}"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <!-- END STATUS TEMPAT TINGGAL DAN NEGARA -->

                <!-- START STATUS PERNIKAHAN DAN AGAMA -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="status_pernikahan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('status_pernikahan') || allRejectedFields.includes('marital_status')}">Status Pernikahan *</label>
                      <br />
                      <b-form-select
                        v-model="form.status_pernikahan"
                        :options="options.status_pernikahan"
                        :class="{'is-invalid': allRejectedFields.includes('status_pernikahan') || allRejectedFields.includes('marital_status')}"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="agama" :class="{'text-danger font-weight-bold': allRejectedFields.includes('agama') || allRejectedFields.includes('religion')}">Agama *</label>
                      <br />
                      <b-form-select
                        v-model="form.agama"
                        :options="options.agama"
                        :class="{'is-invalid': allRejectedFields.includes('agama') || allRejectedFields.includes('religion')}"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <!-- END STATUS PERNIKAHAN DAN AGAMA -->

                <!-- START PENDIDIKAN -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="pendidikan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('pendidikan') || allRejectedFields.includes('education')}">Pendidikan *</label>
                      <br />
                      <b-form-select
                        v-model="form.pendidikan"
                        :options="options.pendidikan"
                        :class="{'is-invalid': allRejectedFields.includes('pendidikan') || allRejectedFields.includes('education')}"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <!-- END PENDIDIKAN -->

                <!-- START TUJUAN DAN SUMBER DANA -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="tujuan_pembukaan_rekening_id" :class="{'text-danger font-weight-bold': allRejectedFields.includes('tujuan_pembukaan_rekening_id') || allRejectedFields.includes('account_opening_purpose_id')}">Tujuan Pembukaan Rekening *</label>
                      <br />
                      <b-form-select
                        v-model="form.tujuan_pembukaan_rekening_id"
                        :options="options.tujuan_pembukaan_rekening"
                        :class="{'is-invalid': allRejectedFields.includes('tujuan_pembukaan_rekening_id') || allRejectedFields.includes('account_opening_purpose_id')}"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="sumber_dana_id" :class="{'text-danger font-weight-bold': allRejectedFields.includes('sumber_dana_id') || allRejectedFields.includes('fund_source_id')}">Sumber Dana *</label>
                      <br />
                      <b-form-select
                        v-model="form.sumber_dana_id"
                        :options="options.sumber_dana"
                        :class="{'is-invalid': allRejectedFields.includes('sumber_dana_id') || allRejectedFields.includes('fund_source_id')}"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <!-- END TUJUAN DAN SUMBER DANA -->

                <!-- START PERKIRAAN NILAI TRANSAKSI -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <b-form-group
                        label="Perkiraan Nilai Transaksi dalam 1 tahun *"
                        :label-class="allRejectedFields.includes('perkiraan_nilai_transaksi') || allRejectedFields.includes('estimated_transaction_value') ? 'text-danger font-weight-bold' : ''"
                      >
                        <b-form-radio-group
                          v-model="form.perkiraan_nilai_transaksi"
                          :options="options.perkiraan_nilai_transaksi"
                          :class="{'is-invalid': allRejectedFields.includes('perkiraan_nilai_transaksi') || allRejectedFields.includes('estimated_transaction_value')}"
                          required
                        ></b-form-radio-group>
                        <div v-if="allRejectedFields.includes('perkiraan_nilai_transaksi') || allRejectedFields.includes('estimated_transaction_value')" class="text-danger small mt-1">Field ini bermasalah</div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <!-- END PERKIRAAN NILAI TRANSAKSI -->

                <!-- START PIHAK TERKAIT -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="nama_pihak_terkait" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nama_pihak_terkait') || allRejectedFields.includes('related_party_name')}">Nama Ahli Waris *</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.nama_pihak_terkait"
                        placeholder="Masukkan nama"
                        :class="{'is-invalid border-danger': allRejectedFields.includes('nama_pihak_terkait') || allRejectedFields.includes('related_party_name')}"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="email mt-3">
                      <label for="hubungan_pihak_terkait" :class="{'text-danger font-weight-bold': allRejectedFields.includes('hubungan_pihak_terkait') || allRejectedFields.includes('related_party_relationship')}"
                        >Hubungan Dengan Ahli Waris *</label
                      >
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.hubungan_pihak_terkait"
                        placeholder="Masukkan hubungan"
                        :class="{'is-invalid border-danger': allRejectedFields.includes('hubungan_pihak_terkait') || allRejectedFields.includes('related_party_relationship')}"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col">
                    <div class="email mt-3">
                      <label for="no_hp_pihak_terkait" :class="{'text-danger font-weight-bold': allRejectedFields.includes('no_hp_pihak_terkait') || allRejectedFields.includes('related_party_phone')}"
                        >No. Telepon Ahli Waris *</label
                      >
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.no_hp_pihak_terkait"
                        placeholder="Masukkan nomor telepon"
                        :class="{'is-invalid border-danger': allRejectedFields.includes('no_hp_pihak_terkait') || allRejectedFields.includes('related_party_phone')}"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="email mt-3">
                      <label for="alamat_pihak_terkait" :class="{'text-danger font-weight-bold': allRejectedFields.includes('alamat_pihak_terkait') || allRejectedFields.includes('related_party_address')}"
                        >Alamat Ahli Waris *</label
                      >
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.alamat_pihak_terkait"
                        placeholder="Masukkan alamat"
                        :class="{'is-invalid border-danger': allRejectedFields.includes('alamat_pihak_terkait') || allRejectedFields.includes('related_party_address')}"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <!-- END PIHAK TERKAIT -->

                <!-- START FOTO KTP -->
                <div class="row mt-3">
                  <div class="col">
                    <span>Foto KTP</span>
                    <b-img
                      v-if="Boolean(!form.foto_ktp)"
                      class="kyc-image"
                      :src="require('@/assets/images/icon/upload-icon.png')"
                      fluid
                      alt="ktp-photo"
                    ></b-img>
                    <b-img
                      v-if="Boolean(form.foto_ktp)"
                      class="kyc-image"
                      :src="form.foto_ktp"
                      fluid
                      alt="ktp-photo"
                    ></b-img>
                    <!-- <b-button
                      v-if="!ekyc_verified"
                      @click="handleShowModalCamera('ktp')"
                      class="w-100 bg-white border-warning text-warning"
                      variant="outline"
                      >Ambil foto</b-button
                    > -->
                  </div>
                  <div class="col">
                    <span>Foto Selfie</span>
                    <b-img
                      v-if="Boolean(!form.foto_selfie)"
                      class="kyc-image"
                      :src="require('@/assets/images/icon/selfie-icon.png')"
                      fluid
                      alt="selfie-photo"
                    ></b-img>
                    <b-img
                      v-if="Boolean(form.foto_selfie)"
                      class="kyc-image"
                      :src="form.foto_selfie"
                      fluid
                      alt="selfie-photo"
                    ></b-img>
                    <!-- <b-button
                      v-if="!ekyc_verified"
                      @click="handleShowModalCamera('selfie')"
                      class="w-100 bg-white border-warning text-warning"
                      variant="outline"
                      >Ambil foto</b-button
                    > -->
                  </div>
                </div>
                <!-- END FOTO KTP -->

                <!-- START TOMBOL SIMPAN -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-4">
                      <button
                        type="submit"
                        class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0"
                        :disabled="!form.foto_ktp || !form.foto_selfie || hasUnresolvedSectionRejection"
                        :title="hasUnresolvedSectionRejection ? 'Perbaiki semua data yang ditolak terlebih dahulu' : ''"
                      >
                        Simpan Data Diri
                      </button>
                    </div>
                  </div>
                </div>
                <!-- END TOMBOL SIMPAN -->
              </b-form>
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <!-- END DATA DIRI -->

    <!-- START KONFIRMASI UPDATE DATA DIRI -->
    <b-modal size="m" v-model="confirmProfileModal">
      <div class="d-block text-center">
        <h3>Apakah anda yakin ?</h3>
        <div v-if="hasFinalRejection" class="mt-3 p-2 border border-danger rounded bg-light">
          <p class="text-danger font-weight-bold mb-1">
            <b-icon icon="exclamation-circle-fill"></b-icon> Perhatian
          </p>
          <p class="text-dark small">Harap pastikan <strong>semua data yang ditandai merah</strong> sudah Anda perbaiki agar Anda dapat melakukan pengajuan kembali.</p>
        </div>
      </div>
      <template #modal-footer>
        <div v-if="loading" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="confirmProfileModal = false" variant="danger"
            >Tidak</b-button
          >
          <b-button @click="confirmUpdateProfile" variant="primary"
            >Ya</b-button
          >
        </div>
      </template>
    </b-modal>
    <!-- END KONFIRMASI UPDATE DATA DIRI -->

    <!-- START DATA PEKERJAAN DAN PENGHASILAN -->
    <DataPekerjaan :allRejectedFields="allRejectedFields" :rejectionMessages="rejectionMessages" @updated="loadData" @dirty="markFieldAsFixed" />
    <DataUsaha :allRejectedFields="allRejectedFields" :rejectionMessages="rejectionMessages" @updated="loadData" @dirty="markFieldAsFixed" />
    <AkunBank :allRejectedFields="allRejectedFields" :rejectionMessages="rejectionMessages" @updated="loadData" @dirty="markFieldAsFixed" />
    <!-- END AKUN BANK -->

    <!-- START KATA SANDI -->
    <!-- <ChangePassword /> -->
    <!-- END KATA SANDI -->

    <!-- START VERIFIKASI EMAIL -->
    <VerifikasiEmail />
    <!-- END VERIFIKASI EMAIL -->

    <!-- START FOTO MODAL -->
    <b-modal
      size="m"
      v-model="showModalCamera"
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <v-easy-camera
          v-model="picture"
          ref="camera"
          :startOnMounted="true"
          output="blob"
          stop="!showModalCamera"
          :resolution="{ width: 1000, height: 1000 }"
          :autoDetectMobile="false"
          :fullscreen="false"
        ></v-easy-camera>
        <div class="row gap-3 p-3">
          <b-button class="col mr-2" @click="handleCaptureCamera"
            >Ambil foto</b-button
          >
          <b-button
            @click="handleCloseModalCamera"
            class="bg-white border-warning text-warning col ml-2"
            variant="outline"
          >
            Batal
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- END FOTO MODAL -->

    <!-- START MODAL SUKSES UNTUK SEMUA KONFIRMASI -->
    <b-modal size="m" v-model="successModal">
      <div class="d-block text-center">
        <b-icon
          icon="check-circle"
          animation="throb"
          variant="success"
          style="width: 120px; height: 120px"
        ></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <template #modal-footer>
        <div>
          <b-button @click="successModal = false" variant="danger"
            >Tutup</b-button
          >
        </div>
      </template>
    </b-modal>
    <!-- END MODAL SUKSES UNTUK SEMUA KONFIRMASI -->
    
    <NewCustomModal
      :visible="readyToReapplyModal"
      size="medium"
      @close="readyToReapplyModal = false"
    >
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="require(`@/assets/images/landing_page/logo-efunding.svg`)"
          alt="logo"
          width="350"
        />

        <span
          class="title-modal"
          style="font-weight: 700; margin-top: 20px; font-size: 30px"
          >Selamat!</span
        >

        <div
          style="
            background-color: #f2f2f2;
            padding: 20px;
            border-radius: 10px;
            margin-top: 30px;
            width: 100%;
            max-width: 500px;
          "
        >
          <div class="text-value" style="color: #274c8e">
            Semua data Anda telah berhasil diperbaiki.<br />
            Anda sudah dapat melakukan <strong>pengajuan kembali</strong>.
          </div>
        </div>

        <div class="modal-action-buttons wrong-modal" style="margin-top: 30px; position: relative;">
          <button
            class="custom-btn danger"
            @click="readyToReapplyModal = false; showProductDropdown = false"
          >
            Tutup
          </button>

          <div style="position: relative; display: inline-block">
            <button
              class="custom-btn primary"
              @click="showProductDropdown = !showProductDropdown"
            >
              Lihat Produk
            </button>
            <div
              v-if="showProductDropdown"
              style="
                position: absolute;
                bottom: 110%;
                left: 50%;
                transform: translateX(-50%);
                background: white;
                border: 1px solid #ddd;
                border-radius: 8px;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                min-width: 180px;
                z-index: 100;
                overflow: hidden;
              "
            >
              <a
                href="/list-produk-deposito"
                style="
                  display: block;
                  padding: 12px 20px;
                  color: #274c8e;
                  font-weight: 600;
                  text-decoration: none;
                  border-bottom: 1px solid #f0f0f0;
                "
                @mouseover="$event.target.style.backgroundColor='#f5f5f5'"
                @mouseleave="$event.target.style.backgroundColor=''"
              >Deposito</a>
              <a
                href="/list-produk-tabungan"
                style="
                  display: block;
                  padding: 12px 20px;
                  color: #274c8e;
                  font-weight: 600;
                  text-decoration: none;
                "
                @mouseover="$event.target.style.backgroundColor='#f5f5f5'"
                @mouseleave="$event.target.style.backgroundColor=''"
              >Tabungan</a>
            </div>
          </div>
        </div>
      </div>
    </NewCustomModal>

    <NewCustomModal
      :visible="unfixedFieldsModal"
      size="medium"
      @close="unfixedFieldsModal = false"
    >
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="require(`@/assets/images/landing_page/logo-efunding.svg`)"
          alt="logo"
          width="350"
        />

        <span
          class="title-modal"
          style="font-weight: 700; margin-top: 20px; font-size: 30px"
          >Perhatian</span
        >

        <div
          style="
            background-color: #f2f2f2;
            padding: 20px;
            border-radius: 10px;
            margin-top: 30px;
            width: 100%;
            max-width: 500px;
          "
        >
          <div class="text-value" style="color: #274c8e">
            Harap perbaiki data berikut yang ditandai merah:
            <br />
            <strong style="color: #dc3545">{{ unfixedFieldsLabels }}</strong>
            <br />
            Semua data tersebut harus diubah agar pengajuan dapat diproses kembali.
          </div>
        </div>

        <div class="modal-action-buttons wrong-modal" style="margin-top: 30px">
          <button
            class="custom-btn danger"
            @click="unfixedFieldsModal = false"
          >
            Tutup
          </button>
        </div>
      </div>
    </NewCustomModal>
  </div>
</template>

<script>
import Pengajuan from "../../api/pengajuan.js";
import Funder from "../../api/funder.js";
import User from "../../api/user.js";
import Provinsi from "../../api/daerahindonesia/provinsi";
import Kecamatan from "../../api/daerahindonesia/kecamatan";
import Kelurahan from "../../api/daerahindonesia/kelurahan";
import Kota from "../../api/daerahindonesia/kota";
import SumberDana from "../../api/sumberdana";
import TujuanPembukaanRekening from "../../api/tujuanpembukaanrekening";
import UserProfile from "../../api/userprofile";
import DefaultPhoto from "../../assets/images/icon/upload-icon.png";
import Corporate from "../../api/corporate/corporate.js";

import BFormInputWithMask from "../../components/masking-input.vue";

import DataUsaha from "./DataUsaha";
import DataPekerjaan from "./DataPekerjaan";
import AkunBank from "./AkunBank";
import ChangePassword from "./ChangePassword";
import VerifikasiEmail from "./VerifikasiEmail";
import DataBadanHukum from "./dataBadanHukum.vue";

// Vue Camera Library
import EasyCamera from "easy-vue-camera";
import { event } from "jquery";
import DataPIC from "./dataPIC.vue";
import EstimatasiTransaksi from "../../api/estimasitransaksi.js";

import NewCustomModal from "../newCustomModal.vue";

export default {
  name: "Profile",
  components: {
    DataPekerjaan,
    DataUsaha,
    AkunBank,
    ChangePassword,
    VerifikasiEmail,
    "v-easy-camera": EasyCamera,
    DataBadanHukum,
    DataPIC,
    BFormInputWithMask,
    NewCustomModal,
  },
  data() {
    return {
      picture: "",
      showModalCamera: false,
      cameraType: "",
      isSameAddress: false,
      date: new Date(),
      items: [],
      profiles: [],
      alamatUpdate: "",
      provinsiUpdate: "",
      kotaUpdate: "",
      kecamatanUpdate: "",
      loading: false,
      kelurahanUpdate: "",
      imageUrl: "",
      originalForm: {},
      photo: {
        ktp: "",
        selfie: "",
        npwp_attachment: "",
        npwp_corporate_attachment: "",
        akta_pendirian: "",
        akta_terakhir: "",
        sk_kemenkumham_file: "",
        sk_kemenkumham_terakhir_file: "",
      },
      form: {
        name: "",
        jenis_kelamin: "",
        alamat: "",
        alamat_terkini: "",
        kelurahan: null,
        kota: null,
        kecamatan: null,
        provinsi: null,
        kelurahan_ktp: null,
        kota_ktp: null,
        kecamatan_ktp: null,
        provinsi_ktp: null,
        negara: "",
        status_tempat_tinggal: "",
        jenis_tanda_pengenal: "",
        nomor_tanda_pengenal: null,
        tempat_diterbitkan: "",
        masa_berlaku_tanda_pengenal: "",
        tempat_lahir: null,
        status_pernikahan: "",
        agama: "",
        pendidikan: "",
        kewarganegaraan: "",
        npwp: null,
        npwp_attachment: "",
        no_handphone: null,
        no_hp_alternatif: null,
        nama_pihak_terkait: "",
        hubungan_pihak_terkait: "",
        no_hp_pihak_terkait: "",
        alamat_pihak_terkait: "",
        tujuan_pembukaan_rekening_id: null,
        sumber_dana_id: null,
        perkiraan_nilai_transaksi: null,
        foto_ktp: "",
        foto_selfie: "",
        corporate: {
          legal_entity: null,
          name: null,
        },
      },
      mask: {
        is_pns: false,
        npwp: null,
      },
      allRejectedFields: [],
      rejectionMessages: [],
      modalCamera: {
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: [],
        provinsi_ktp: [],
      },
      options: {
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: [],
        provinsi_ktp: [],
        kota_ktp: [],
        kecamatan_ktp: [],
        kelurahan_ktp: [],
        status_pernikahan: [
          { text: "Belum menikah", value: "belum_menikah" },
          { text: "Menikah", value: "menikah" },
          { text: "Duda", value: "duda" },
          { text: "Janda", value: "janda" },
        ],
        jenis_tanda_pengenal: [
          // { text: "KTP", value: "ktp" },
          // { text: "SIM", value: "sim" },
          // { text: "PASSPOR", value: "passpor" },
          // { text: "KITAS", value: "kitas" },
          // { text: "KK", value: "kk" }
        ],
        status_tempat_tinggal: [
          { text: "Pribadi", value: "pribadi" },
          { text: "Keluarga", value: "keluarga" },
          { text: "Sewa / Kontrak", value: "sewa_kontrak" },
          { text: "Rumah Dinas", value: "rumah_dinas" },
        ],
        agama: [
          { text: "Islam", value: "islam" },
          { text: "Kristen", value: "kristen" },
          { text: "Hindu", value: "hindu" },
          { text: "Budha", value: "budha" },
          { text: "Konghucu", value: "konghucu" },
          { text: "Katolik", value: "katolik" },
        ],
        pendidikan: [
          { text: "SMA", value: "sma" },
          { text: "Akademi / Diploma", value: "akademi/diploma" },
          { text: "STRATA I", value: "strata_1" },
          { text: "STRATA II", value: "strata_2" },
          { text: "STRATA III", value: "strata_3" },
          { text: "Lainnya", value: "lainnya" },
        ],
        kewarganegaraan: [
          { text: "WNI", value: "wni" },
          { text: "WNA", value: "wna" },
        ],
        sumber_dana: [],
        tujuan_pembukaan_rekening: [],
        jenis_kelamin: [
          { text: "Pria", value: "pria" },
          { text: "Wanita", value: "wanita" },
        ],
        legalEntity: [],
      },
      errors: {
        nomor_tanda_pengenal: "",
      },
      alamatCheck: false,
      readonly: false,
      email: "",
      successModal: false,
      confirmProfileModal: false,
      unfixedFieldsModal: false,
      unfixedFieldsLabels: "",
      modalText: "",
      ekyc_verified: false,
      errors: {
        no_handphone: "",
        no_hp_alternatif: "",
      },
      no_handphone_disable: false,
      isLoading: false,
      loadingchangeProvince: false,
      loadingchangeProvinceKTP: false,
      loadingKotaChange: false,
      loadingKotaChangeKTP: false,
      loadingKecamatanChange: false,
      loadingKecamatanChangeKTP: false,
      hasPendingRejection: false,
      hasFinalRejection: false,
      readyToReapplyModal: false,
      showProductDropdown: false,
      isManualCheckboxChange: false,
      isUpdate: false,
    };
  },
  watch: {
    "form.kewarganegaraan": function (newVal) {
      this.updateJenisTandaPengenalOptions(newVal);
    },
    // Sebelumnya sync ini jalan lewat computed `state()` — membaca computed di
    // template otomatis menjalankan getter-nya, jadi efek sampingnya (menyalin
    // alamat KTP) ikut terpicu. Saat direfactor jadi method biasa (`sameAddressChange`),
    // `:checked="sameAddressChange"` di template cuma mengambil referensi fungsinya,
    // tidak pernah memanggilnya, jadi sinkronisasi berhenti total. Watcher di sini
    // menggantikan efek samping computed itu dengan cara yang eksplisit.
    isSameAddress() {
      this.sameAddressChange();
    },
    // Real-time: selama checkbox aktif, ketikan di alamat KTP langsung ikut
    // muncul di alamat domisili tanpa perlu toggle checkbox lagi.
    "form.alamat": function (newVal) {
      if (this.isSameAddress) {
        this.form.alamat_terkini = newVal;
      }
    },
    form: {
      handler(newVal) {
        if (this.isLoading || !this.originalForm) return;
        
        // Loop through all currently rejected fields
        this.allRejectedFields.forEach(field => {
          // Check if value is different from original rejected value
          const currentVal = newVal[field];
          const originalVal = this.originalForm[field];
          
          if (currentVal !== originalVal) {
            this.markFieldAsFixed(field);
          }
        });
      },
      deep: true
    }
  },
  mounted() {
    this.loadData();
    this.updateJenisTandaPengenalOptions(this.form.kewarganegaraan);
  },
  activated() {
    this.loadData();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    sectionRejectionMessages() {
      if (!this.rejectionMessages) return [];
      
      return this.rejectionMessages.map(msg => {
        // Data Diri section shows fields belonging to 'UserProfile' model
        const filteredFields = msg.fields ? msg.fields.filter(f => {
          const model = (f.model || '').trim();
          // Case-insensitive match or fallback to check if model is present
          return model.toLowerCase() === 'userprofile';
        }) : [];

        if (filteredFields.length > 0) {
          return {
            note: msg.note,
            fields: filteredFields
          };
        }
        return null;
      }).filter(msg => msg !== null);
    },
    hasUnresolvedSectionRejection() {
      return this.sectionRejectionMessages.some(msg => msg.fields && msg.fields.length > 0);
    },
    getEndDate() {
      var endDate = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        10
      );
      return endDate.toISOString().slice(0, 10);
    },
  },
  methods: {
    sameAddressChange() {
      if (this.isSameAddress) {
        this.form.alamat_terkini = this.form.alamat;
        this.form.provinsi = this.form.provinsi_ktp;
        this.form.kota = this.form.kota_ktp;
        this.form.kecamatan = this.form.kecamatan_ktp;
        this.form.kelurahan = this.form.kelurahan_ktp;
        // Ikut salin daftar pilihan kota/kecamatan/kelurahan milik KTP, bukan
        // cuma id-nya — kalau tidak, dropdown domisili bisa menyimpan id yang
        // valid tapi tidak punya opsi yang cocok untuk ditampilkan (list-nya
        // masih milik provinsi/kota domisili yang lama).
        this.options.kota = this.options.kota_ktp;
        this.options.kecamatan = this.options.kecamatan_ktp;
        this.options.kelurahan = this.options.kelurahan_ktp;
      } else {
        // Kembalikan ke alamat domisili yang tersimpan sebelum checkbox dicentang.
        this.form.alamat_terkini = this.alamatUpdate;
        this.form.provinsi = this.provinsiUpdate;
        this.form.kota = this.kotaUpdate;
        this.form.kecamatan = this.kecamatanUpdate;
        this.form.kelurahan = this.kelurahanUpdate;
      }
    },
    updateJenisTandaPengenalOptions(kewarganegaraan) {
      if (kewarganegaraan === "wni") {
        this.options.jenis_tanda_pengenal = [{ text: "KTP", value: "ktp" }];
      } else if (kewarganegaraan === "wna") {
        this.options.jenis_tanda_pengenal = [
          { text: "KITAS", value: "kitas" },
          { text: "PASSPOR", value: "passpor" },
        ];
      } else {
        this.options.jenis_tanda_pengenal = [];
      }
    },
    async loadData() {
      this.isLoading = true;
      try {
        // 1. Get Submissions to check statuses
        const resSub = await Pengajuan.pengajuanFunder();
        const dataList = Array.isArray(resSub.data.data) ? resSub.data.data : (resSub.data.data.data || []);
        
        // 2. Get User Profile Data
        const resProf = await Funder.show(this.currentUser.info.id);
        const userProfile = resProf.data.data ? resProf.data.data.profile : null;
        
        // Cek status 13 (Menunggu konfirmasi admin)
        this.hasPendingRejection = dataList.some(item => item.status_pengajuan_id == 13);
        
        // Cari pengajuan terakhir yang ditolak secara final (status_pengajuan_id: 4)
        const rejectedSubmissions = dataList.filter(item => item.status_pengajuan_id == 4);
        
        // Urutkan pengajuan terakhir berdasarkan updated_at terbaru
        if (rejectedSubmissions.length > 0) {
          rejectedSubmissions.sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at));
        }
        
        const latestRejected = rejectedSubmissions[0];
        
        // Comprehensive check of all profile-related timestamps for Corporate and Individual
        const profileTS = userProfile ? new Date(userProfile.updated_at).getTime() : 0;
        const dataUsahaTS = (resProf.data.data && resProf.data.data.data_usaha) ? new Date(resProf.data.data.data_usaha.updated_at).getTime() : 0;
        const dataPicTS = (resProf.data.data && resProf.data.data.data_pic) ? new Date(resProf.data.data.data_pic.updated_at).getTime() : 0;
        const dataPekerjaanTS = (resProf.data.data && resProf.data.data.data_pekerjaan) ? new Date(resProf.data.data.data_pekerjaan.updated_at).getTime() : 0;
        
        const latestProfileUpdateTS = Math.max(profileTS, dataUsahaTS, dataPicTS, dataPekerjaanTS);
        const profileUpdatedAt = new Date(latestProfileUpdateTS);
        const rejectionUpdatedAt = latestRejected ? new Date(latestRejected.updated_at || latestRejected.created_at) : new Date(0);

        let fields = [];
        let messages = [];

        // Modern Rejection UI logic using the check-rejection endpoint
        try {
          const resRejectStatus = await Pengajuan.checkRejection();
          if (resRejectStatus.data.meta.code === 200 && resRejectStatus.data.data.has_rejection) {
            const rejectData = resRejectStatus.data.data;
            this.hasFinalRejection = true;
            fields = rejectData.unresolved_fields || [];
        
            // Tampilkan modal siap pengajuan ulang jika semua kondisi terpenuhi
            if (
              rejectData.has_rejection === true &&
              rejectData.is_fully_resolved === true &&
              rejectData.is_rejection_resolved === true
            ) {
              this.readyToReapplyModal = true;
            }
        
            const note = rejectData.rejection_reason;
            if (note) {
            messages.push({
                note: note,
                fields: fields.map(f => {
                  const label = this.formatFieldLabel(f);
                  const model = (typeof f === 'object' && f.model ? f.model : '').trim();
                  const field = typeof f === 'object' ? f.field : f;
                  return { label, model, field };
                })
              });
            }
          } else {
            this.hasFinalRejection = false;
          }
        } catch (e) {
          console.error("Gagal cek rejection status:", e);
        }

        this.allRejectedFields = [...new Set(fields.map(f => {
          const fieldName = typeof f === 'object' ? f.field : f;
          return fieldName.toLowerCase().replace(/ /g, '_');
        }))];
        this.rejectionMessages = messages;

        // Populate Form with Profile Data
        this.profiles = resProf.data.data;
        if (resProf.data.data != null) {
          this.isUpdate = true;
        }
        this.form = userProfile || {};
        this.email = resProf.data.data.email;
        this.form.name = resProf.data.data.name;
        this.form.no_handphone =
          resProf.data.data.no_telpon || this.currentUser.info.no_telpon;
        this.alamatUpdate = userProfile.alamat_terkini || "";
        this.provinsiUpdate = userProfile.provinsi || "";
        this.kotaUpdate = userProfile.kota || "";
        this.kecamatanUpdate = userProfile.kecamatan || "";
        this.kelurahanUpdate = userProfile.kelurahan || "";
        this.ekyc_verified = userProfile.ekyc_verified == 1;
        if (resProf.data.data.no_telpon) this.no_handphone_disable = true;

        if (userProfile.npwp_attachment != null) {
          this.photo.npwp_attachment = userProfile.npwp_attachment;
          this.form.npwp_attachment = "";
        }

        // Normalize this.form to handle null/undefined as empty strings for consistent comparison
        // But avoid converting corporate object to string
        Object.keys(this.form).forEach(key => {
          if (key !== "corporate" && (this.form[key] === null || this.form[key] === undefined)) {
            this.form[key] = "";
          }
        });

        this.originalForm = JSON.parse(JSON.stringify(this.form || {}));
        if (
          this.form.alamat === this.form.alamat_terkini &&
          this.form.provinsi === this.form.provinsi_ktp &&
          this.form.kota === this.form.kota_ktp &&
          this.form.kecamatan === this.form.kecamatan_ktp &&
          this.form.kelurahan === this.form.kelurahan_ktp
        ) {
          this.isSameAddress = true;
        } else {
          this.isSameAddress = false;
        }


        // Get Provinsi data
        const responseProvinsi = await this.$getListWilayah("provinsi");
        const provinsiArray = responseProvinsi.data || [];
        const arrData = provinsiArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.provinsi = arrData;
        this.options.provinsi_ktp = arrData;

        // Handle Provinsi → Kota
        if (this.form.provinsi && this.form.provinsi_ktp) {
          if (this.isSameAddress) {
            const responseKota = await this.$getListWilayah(
              "kota",
              this.form.provinsi
            );
            const kotaArray = responseKota.data || [];
            const arrData = kotaArray.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kota = arrData;
            this.options.kota_ktp = arrData;
          } else {
            const responseKota1 = await this.$getListWilayah(
              "kota",
              this.form.provinsi
            );
            const kotaArray1 = responseKota1.data || [];
            const arrData1 = kotaArray1.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kota = arrData1;

            const responseKota2 = await this.$getListWilayah(
              "kota",
              this.form.provinsi_ktp
            );
            const kotaArray2 = responseKota2.data || [];
            const arrData2 = kotaArray2.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kota_ktp = arrData2;
          }
        }

        // // Handle Kota → Kecamatan
        if (this.form.kota && this.form.kota_ktp) {
          if (this.isSameAddress) {
            const responseKecamatan = await this.$getListWilayah(
              "kecamatan",
              this.form.kota
            );
            const kecamatanArray = responseKecamatan.data || [];
            const arrData = kecamatanArray.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kecamatan = arrData;
            this.options.kecamatan_ktp = arrData;
          } else {
            const responsekecamatan1 = await this.$getListWilayah(
              "kecamatan",
              this.form.kota
            );
            const kecamatanArray1 = responsekecamatan1.data || [];
            const arrKecamatan1 = kecamatanArray1.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kecamatan = arrKecamatan1;

            const responsekecamatan2 = await this.$getListWilayah(
              "kecamatan",
              this.form.kota_ktp
            );
            const kecamatanArray2 = responsekecamatan2.data || [];
            const arrKecamatan2 = kecamatanArray2.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kecamatan_ktp = arrKecamatan2;
          }
        }

        // // Handle Kecamatan → Kelurahan
        if (this.form.kecamatan && this.form.kecamatan_ktp) {
          if (this.isSameAddress) {
            const responseKelurahan = await this.$getListWilayah(
              "kelurahan",
              this.form.kecamatan
            );
            const kelurahanArray = responseKelurahan.data || [];
            const arrData = kelurahanArray.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kelurahan = arrData;
            this.options.kelurahan_ktp = arrData;
          } else {
            const responseKelurahan1 = await this.$getListWilayah(
              "kelurahan",
              this.form.kecamatan
            );
            const kelurahanArray1 = responseKelurahan1.data || [];
            const arrKlurahan1 = kelurahanArray1.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kelurahan = arrKlurahan1;

            const responseKelurahan2 = await this.$getListWilayah(
              "kelurahan",
              this.form.kecamatan_ktp
            );
            const kelurahanArray2 = responseKelurahan2.data || [];
            const arrKelurahan2 = kelurahanArray2.map((item) => ({
              value: item.id,
              text: item.name,
            }));
            this.options.kelurahan_ktp = arrKelurahan2;
          }
        }

        // // Get Sumber dana data
        const sumberRes = await SumberDana.index();
        this.options.sumber_dana = sumberRes.data.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));

        // GET estimasi Transaksi
        const estimasiTransaksi = await EstimatasiTransaksi.indexV3("personal");
        this.options.perkiraan_nilai_transaksi =
          estimasiTransaksi.data.data.map((item) => ({
            value: item.name,
            text: item.name,
          }));

        // // Get Tujuan Pembukaan rekening data
        const tujuanRes = await TujuanPembukaanRekening.index();
        const tujuanArr = tujuanRes.data.data.data.map((item) => ({
          value: item.id,
          text: item.tujuan,
        }));
        this.options.tujuan_pembukaan_rekening = tujuanArr;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    updateMessage() {
      this.message = "Message updated!";
    },

    async provinsiChange() {
      this.loadingchangeProvince = true;
      // this.form.kota = null;
      try {
        const responseKota = await this.$getListWilayah(
          "kota",
          this.form.provinsi
        );
        const kotaArray = responseKota.data || [];
        const arrData = kotaArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kota = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingchangeProvince = false;
      }
    },

    async provinsiChangeKtp() {
      this.loadingchangeProvinceKTP = true;
      // this.form.kota_ktp = null;
      // Real-time: selama checkbox "sesuai KTP" aktif, provinsi domisili ikut
      // berubah begitu provinsi KTP dipilih, tanpa menunggu checkbox di-toggle ulang.
      if (this.isSameAddress) {
        this.form.provinsi = this.form.provinsi_ktp;
      }
      try {
        const responseKota = await this.$getListWilayah(
          "kota",
          this.form.provinsi_ktp
        );
        const kotaArray = responseKota.data || [];
        const arrData = kotaArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kota_ktp = arrData;
        if (this.isSameAddress) {
          // List kota lama sudah tidak relevan untuk provinsi yang baru dipilih.
          this.options.kota = arrData;
          this.form.kota = this.form.kota_ktp;
        }
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingchangeProvinceKTP = false;
      }
    },

    async kotaChange() {
      this.loadingKotaChange = true;
      // this.form.kecamatan = null;
      try {
        const responseKecamatan = await this.$getListWilayah(
          "kecamatan",
          this.form.kota
        );
        const kecamatanArray = responseKecamatan.data || [];
        const arrData = kecamatanArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kecamatan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKotaChange = false;
      }
    },

    async kotaChangeKtp() {
      this.loadingKotaChangeKTP = true;
      // this.form.kecamatan_ktp = null;
      if (this.isSameAddress) {
        this.form.kota = this.form.kota_ktp;
      }
      try {
        const responseKecamatan = await this.$getListWilayah(
          "kecamatan",
          this.form.kota_ktp
        );
        const kecamatanArray = responseKecamatan.data || [];
        const arrData = kecamatanArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kecamatan_ktp = arrData;
        if (this.isSameAddress) {
          this.options.kecamatan = arrData;
          this.form.kecamatan = this.form.kecamatan_ktp;
        }
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKotaChangeKTP = false;
      }
    },

    async kecamatanChange() {
      this.loadingKecamatanChange = true;
      // this.form.kelurahan = null;
      try {
        const responseKelurahan = await this.$getListWilayah(
          "kelurahan",
          this.form.kecamatan
        );
        const kelurahanArray = responseKelurahan.data || [];
        const arrData = kelurahanArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kelurahan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKecamatanChange = false;
      }
    },

    async kecamatanChangeKtp() {
      this.loadingKecamatanChangeKTP = true;
      // this.form.kelurahan_ktp = null;
      if (this.isSameAddress) {
        this.form.kecamatan = this.form.kecamatan_ktp;
      }
      try {
        const responseKelurahan = await this.$getListWilayah(
          "kelurahan",
          this.form.kecamatan_ktp
        );
        const kelurahanArray = responseKelurahan.data || [];
        const arrData = kelurahanArray.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.kelurahan_ktp = arrData;
        if (this.isSameAddress) {
          this.options.kelurahan = arrData;
          this.form.kelurahan = this.form.kelurahan_ktp;
        }
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKecamatanChangeKTP = false;
      }
    },
    // Kelurahan adalah level paling bawah, tidak ada cascade setelahnya —
    // cukup salin nilainya saja saat checkbox "sesuai KTP" aktif.
    kelurahanChangeKtp() {
      if (this.isSameAddress) {
        this.form.kelurahan = this.form.kelurahan_ktp;
      }
    },
    validatePhoneNumber() {
      const regex = /^62[0-9]{9,14}$/;
      this.errors.no_handphone = "";

      if (!this.form.no_handphone) {
        this.errors.no_handphone = "Nomor handphone tidak boleh kosong.";
      } else if (isNaN(this.form.no_handphone)) {
        this.errors.no_handphone =
          "Nomor handphone hanya boleh mengandung angka.";
      } else if (!regex.test(this.form.no_handphone)) {
        this.errors.no_handphone =
          "Nomor handphone harus diawali dengan '62' dan terdiri dari 9-14 digit angka.";
      }
    },
    validateNomorTandaPengenal() {
      this.errors.nomor_tanda_pengenal = "";

      if (this.form.jenis_tanda_pengenal == "ktp") {
        const nomorTandaPengenal = this.form.nomor_tanda_pengenal.toString();
        if (nomorTandaPengenal.length != 16) {
          this.errors.nomor_tanda_pengenal =
            "Nomor Tanda Pengenal KTP harus 16 angka.";
          return false;
        } else {
          this.errors.nomor_tanda_pengenal = "";
        }
      }
      return true;
    },

    updateDataDiri() {
      this.validatePhoneNumber();
      if (!this.validateNomorTandaPengenal()) {
        return;
      }
      if (this.errors.no_handphone || this.errors.no_hp_alternatif) {
        return;
      }

      // Cek apakah ada field rejection yang belum disentuh (HARUS DIPERBAIKI SEMUA)
      const unfixed = this.getUnfixedFields();
      if (unfixed.length > 0) {
        const labels = unfixed.map(f => {
          const fieldKey = f.toLowerCase().replace(/ /g, '_');
          if (fieldKey.includes('pihak_terkait')) return 'AHLI WARIS';
          if (fieldKey === 'npwp_attachment') return 'NPWP GAMBAR / PDF (OPSIONAL)';
          if (fieldKey === 'alamat_terkini') return 'ALAMAT DOMISILI';
          return f.replace(/_/g, ' ').toUpperCase();
        });
        // Unique-ify labels in case multiple 'Ahli Waris' fields are unfixed
        this.unfixedFieldsLabels = [...new Set(labels)].join(', ');
        this.unfixedFieldsModal = true;
        return; // Blokir pemunculan modal konfirmasi
      }

      this.confirmProfileModal = true;
    },
    getChangedFields() {
      const changedFields = {};

      // ⛔ Cegah error jika originalForm belum ter-set
      if (!this.originalForm || typeof this.originalForm !== "object") {
        return this.form; // atau bisa return {} jika kamu ingin anggap tidak ada perubahan
      }

      for (const key in this.form) {
        const current =
          this.form[key] === null || this.form[key] === undefined
            ? ""
            : this.form[key];
        const original =
          this.originalForm[key] === null ||
          this.originalForm[key] === undefined
            ? ""
            : this.originalForm[key];
        if (current !== original) {
          changedFields[key] = this.form[key];
        }
      }

      return changedFields;
    },
    getUnfixedFields() {
      if (!this.hasFinalRejection) return [];
      const changed = this.getChangedFields();
      return this.allRejectedFields.filter(field => {
        // Mapping field rejection ke key form personal
        let formKey = field;
        if (field === 'nama_depan' || field === 'nama_belakang') formKey = 'name';
        if (field === 'npwp') formKey = 'npwp';
        
        // Jika field ada di form personal, cek apakah sudah diubah
        if (Object.prototype.hasOwnProperty.call(this.form, formKey)) {
          // Khusus untuk 'name', kita anggap resolved jika 'name' ada di changed fields
          return !Object.prototype.hasOwnProperty.call(changed, formKey);
        }
        
        // Jika field tidak ditemukan di form ini, kita asumsikan itu adalah data corporate 
        // yang akan divalidasi di bagian lain atau sudah diperbaiki di form corporate.
        return false;
      });
    },
    confirmUpdateProfile() {
      this.loading = true;
      const payload = this.getChangedFields();

      if (Object.keys(payload).length === 0) {
        this.loading = false;
        this.modalText = "Tidak ada perubahan data";
        this.confirmProfileModal = false;
        this.successModal = true;
        return;
      }
      UserProfile.update(payload)
        .then((res) => {
          this.loading = false;
          if (res.data.meta.code == 200) {
            this.modalText = this.hasFinalRejection 
              ? "Data berhasil diubah, Anda dapat mengajukan kembali."
              : "Data diri berhasil diubah";
            this.confirmProfileModal = false;
            this.successModal = true;
            this.loadData();
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },

    handleShowModalCamera(type) {
      this.showModalCamera = true;
      this.cameraType = type;
    },

    handleCloseModalCamera() {
      this.showModalCamera = false;
      this.cameraType = "";
      this.$refs.camera.stop();
    },

    blobToBase64(blob) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },

    markFieldAsFixed(fieldKey) {
      if (!fieldKey) return;
      
      const normalizedKey = fieldKey.toLowerCase().replace(/ /g, '_');
      
      // 1. Remove from border/label highlighting array
      if (this.allRejectedFields.includes(normalizedKey)) {
        this.allRejectedFields = this.allRejectedFields.filter(f => f !== normalizedKey);
      }
      
      // 2. Remove from the rejection alert list (rejectionMessages)
      const friendlyLabelToRemove = this.formatFieldLabel(normalizedKey);
      
      this.rejectionMessages.forEach(msg => {
        if (msg.fields) {
          // Remove only ONE instance of the field from the list
          const index = msg.fields.findIndex(f => {
            const fieldName = typeof f === 'object' ? f.field : f;
            if (!fieldName) return false;
            return String(fieldName).toLowerCase().replace(/ /g, '_') === normalizedKey;
          });
          
          if (index !== -1) {
            msg.fields.splice(index, 1);
          }
        }
      });
    },
    formatFieldLabel(f) {
      if (!f) return '';
      const fieldName = typeof f === 'object' ? f.field : f;
      if (!fieldName) return '';
      const fieldKey = String(fieldName).toLowerCase().replace(/ /g, '_');
      
      // Special Mappings
      if (fieldKey.includes('nama_pihak_terkait') || fieldKey.includes('related_party_name')) return 'NAMA AHLI WARIS';
      if (fieldKey.includes('hubungan_pihak_terkait') || fieldKey.includes('related_party_relationship')) return 'HUBUNGAN AHLI WARIS';
      if (fieldKey.includes('no_hp_pihak_terkait') || fieldKey.includes('related_party_phone')) return 'NOMOR TELEPON AHLI WARIS';
      if (fieldKey.includes('alamat_pihak_terkait') || fieldKey.includes('related_party_address')) return 'ALAMAT AHLI WARIS';
      if (fieldKey === 'pihak_terkait') return 'AHLI WARIS';
      
      if (fieldKey === 'npwp_attachment' || fieldKey === 'taxpayer_document_path') return 'NPWP GAMBAR / PDF';
      if (fieldKey === 'alamat_terkini' || fieldKey === 'current_address') return 'ALAMAT DOMISILI';
      if (fieldKey === 'ratarata_penghasilan_perbulan' || fieldKey === 'estimated_transaction_value') return 'RATA-RATA PENGHASILAN DALAM 1 BULAN';
      if (fieldKey === 'nama_tempatkerja' || fieldKey === 'company_name') return 'NAMA TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'alamat_tempatkerja' || fieldKey === 'company_address') return 'ALAMAT TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'jabatan' || fieldKey === 'position_id') return 'JABATAN';
      if (fieldKey === 'legal_entity_name') return 'NAMA BADAN HUKUM';
      if (fieldKey === 'legal_entity_id' || fieldKey === 'legal_entity_type_id') return 'JENIS BADAN HUKUM';
      if (fieldKey === 'business_field_id' || fieldKey === 'bidang_usaha_id') return 'BIDANG USAHA';
      if (fieldKey === 'bank_id' || fieldKey === 'bank') return 'NAMA BANK';
      if (fieldKey === 'account_number') return 'NOMOR REKENING';
      if (fieldKey === 'account_name') return 'NAMA PEMILIK REKENING';
      if (fieldKey === 'taxpayer_number' || fieldKey === 'npwp') return 'NPWP';
      if (fieldKey === 'identity_number') return 'NOMOR IDENTITAS / KTP';
      if (fieldKey === 'gender' || fieldKey === 'jenis_kelamin') return 'JENIS KELAMIN';
      if (fieldKey === 'identity_address' || fieldKey === 'alamat') return 'ALAMAT KTP';
      if (fieldKey === 'place_of_birth' || fieldKey === 'tempat_lahir') return 'TEMPAT LAHIR';
      if (fieldKey === 'date_of_birth' || fieldKey === 'tanggal_lahir') return 'TANGGAL LAHIR';
      if (fieldKey === 'nationality' || fieldKey === 'kewarganegaraan') return 'KEWARGANEGARAAN';
      
      // Default formatting
      return String(fieldName).replace(/_id$/i, '').replace(/_/g, ' ').toUpperCase();
    },

    handleCaptureCamera() {
      this.$refs.camera.snap();
      this.photo[this.cameraType] = "";
      setTimeout(() => {
        this.blobToBase64(this.picture).then((res) => {
          if (this.cameraType === "ktp") {
            this.form.foto_ktp = res;
            this.markFieldAsFixed('foto_ktp');
          } else if (this.cameraType === "selfie") {
            this.form.foto_selfie = res;
            this.markFieldAsFixed('foto_selfie');
          }
        });
        this.processFile(this.picture);
      }, 1000);
    },

    processFile(blob) {
      // read the files
      var reader = new FileReader();

      if (blob instanceof Blob) {
        reader.readAsArrayBuffer(blob);
        let vm = this;

        reader.onload = function (event) {
          // blob stuff
          var blob = new Blob([event.target.result]); // create blob...
          window.URL = window.URL || window.webkitURL;

          var blobURL = window.URL.createObjectURL(blob); // and get it's URL

          // helper Image object
          var image = new Image();
          image.src = blobURL;
          image.onload = function () {
            // have to wait till it's loaded
            var canvas = document.createElement("canvas");
            var width = image.width;
            var height = image.height;

            // calculate the width and height, constraining the proportions
            if (width > height) {
              if (width > 100) {
                //height *= max_width / width;
                height = 650;
              }
            } else {
              if (height > 100) {
                //width *= max_height / height;
                width = 490;
              }
            }

            // resize the canvas and draw the image data into it
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);

            canvas.toBlob(async function (blob) {
              // console.log("width", width);
              // console.log("height", height);
              vm.blobToBase64(blob).then((res) => {
                if (vm.cameraType === "ktp") {
                  vm.form.foto_ktp = res;
                } else if (vm.cameraType === "selfie") {
                  vm.form.foto_selfie = res;
                }
              });
              vm.showModalCamera = false;
            });
          };
        };
      }
    },

    validationLength(event, value, length) {
      if (value && value.length >= length && event.key !== "Backspace") {
        return event.preventDefault();
      }
    },

    isPDF(file) {
      // Jika file berupa base64, periksa prefixnya
      if (file.startsWith("data:application/pdf")) return true;
      // Jika file berupa path, cek ekstensi file-nya
      const ext = file.split(".").pop().toLowerCase();
      return ext === "pdf";
    },

    handleNPWPAttachment(e) {
      this.photo.npwp_attachment = e.target.files[0];
      this.markFieldAsFixed('npwp_attachment');
      
      const file = e.target.files[0];
      if (!file) return;

      // Validasi: hanya terima file dengan tipe image atau PDF
      if (
        !(file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        alert("File harus berupa gambar atau PDF.");
        event.target.value = null; // reset input file
        return;
      }

      // Jika API Anda mengharuskan upload file melalui FormData,
      // Anda bisa mengirim file langsung. Di sini, contoh mengonversi ke base64:
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.npwp_attachment = e.target.result;
        this.photo.npwp_attachment = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    handleFileUpload(event, fieldName) {
      const file = event.target.files[0];
      if (!file) return;

      // Validasi tipe file
      if (
        !(file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        alert("File harus berupa gambar atau PDF.");
        event.target.value = null;
        return;
      }

      // Konversi ke base64 (untuk preview)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form[fieldName] = e.target.result;
        this.photo[fieldName] = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    handleBlur(formName){
      this.mask[formName] = !this.mask[formName]      
    },
    callbackMasking(formName){
      this.mask[formName] = !this.mask[formName]
      return this.mask[formName]
    }
  },
};
</script>

<style scoped>
.collapsed .when-open {
  display: none;
}

.not-collapsed .when-closed {
  display: none;
}

.kyc-image {
  width: 100%;
  height: auto;
  padding: 0 !important;
  object-fit: cover;
}

/* Penyeragaman fokus (garis biru) untuk semua input & select */
::v-deep .form-control:focus,
::v-deep .custom-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Penyeragaman tampilan is-invalid (garis merah) */
::v-deep .form-control.is-invalid,
::v-deep .form-control.is-invalid:read-only,
::v-deep .form-control.is-invalid:disabled,
::v-deep .custom-select.is-invalid {
  border: 1px solid #dc3545 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}

::v-deep .is-invalid:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Modal and Utility Classes */
.flex-column {
  display: flex;
  flex-direction: column;
}
.title-modal {
  font-size: 20px;
  color: #274c8e;
  font-weight: 500;
}
.modal-action-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  margin-top: 20px;
  padding: 0 90px;
}
.custom-btn {
  background-color: #00a1ca;
  color: white !important;
  padding: 1rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}
.custom-btn.danger {
  background-color: #dc3545;
}
.modal-action-buttons.wrong-modal {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 20px;
  margin-top: 20px;
  padding: 0 60px;
}

/* Enforce red border for rejection highlights */
.is-invalid, 
.is-invalid-vselect .vs__dropdown-toggle,
.is-invalid-vselect input,
.is-invalid .custom-control-label::before,
.border-danger {
  border: 1px solid #dc3545 !important;
}

/* Fix for v-select specifically */
.is-invalid-vselect .vs__dropdown-toggle {
  border-color: #dc3545 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/profil.vue